import { Component } from '@angular/core';

@Component({
    selector: 'balance-chart-runner',
    templateUrl: 'balance-chart-runner.component.html',
    styleUrls: ['balance-chart-runner.component.less'],
})
export class BalanceChartRunnerComponent {
}
